module.exports = __webpack_public_path__ + "img/bg_title.653b92d4.png";